var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9764 10.6667H12.559C12.9787 10.6667 13.3878 10.7988 13.7283 11.0442C14.0689 11.2896 14.3235 11.6359 14.4563 12.0341L14.667 12.6667L7.02166 15.0194C6.36619 15.2209 5.65829 15.1622 5.04499 14.8554L0.666992 12.6667V8.00008H1.33366C2.07033 8.00008 3.93766 8.29208 4.66699 9.33342H6.66699C7.37424 9.33342 8.05251 9.61437 8.55261 10.1145C9.05271 10.6146 9.33366 11.2928 9.33366 12.0001H5.33366M10.0003 3.33341V4.66675M13.3337 4.00008C13.3337 5.84103 11.8413 7.33342 10.0003 7.33342C8.15938 7.33342 6.66699 5.84103 6.66699 4.00008C6.66699 2.15913 8.15938 0.666748 10.0003 0.666748C11.8413 0.666748 13.3337 2.15913 13.3337 4.00008Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.e7922a59.svg";
export { ForwardRef as ReactComponent };